export const lettersSpecialRegex = /^[A-Za-z \-']*$/;
